(function () {
  var GLYPHS = '01#/\\<>_=+~*%&$@[]|';
  function noise() { return GLYPHS.charAt(Math.floor(Math.random() * GLYPHS.length)); }
  var peakCache = {};
  var actx = null;
  var current = null; // { root, audio, btn, ... }

  function fmt(t) {
    if (!isFinite(t) || t < 0) t = 0;
    var m = Math.floor(t / 60), s = Math.floor(t % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }
  function rng(seed) {
    return function () {
      seed |= 0; seed = (seed + 0x6D2B79F5) | 0;
      var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function maskText(r) {
    var parts = [], n = 3 + Math.floor(r() * 2), lens = [2, 3, 3, 4];
    for (var i = 0; i < n; i++) {
      var l = lens[Math.floor(r() * lens.length)], p = '';
      while (l--) p += 'X';
      parts.push(p);
    }
    return parts.join('_');
  }

  function decodePeaks(src, n) {
    if (peakCache[src]) return peakCache[src];
    var AC = window.AudioContext || window.webkitAudioContext;
    peakCache[src] = new Promise(function (resolve) {
      if (!AC || !window.fetch) return resolve(null);
      fetch(src).then(function (r) { return r.arrayBuffer(); }).then(function (buf) {
        actx = actx || new AC();
        return new Promise(function (ok, no) { actx.decodeAudioData(buf, ok, no); });
      }).then(function (ab) {
        var d = ab.getChannelData(0), step = Math.floor(d.length / n) || 1, out = [], max = 0, i, j;
        for (i = 0; i < n; i++) {
          var peak = 0;
          for (j = 0; j < step; j += 16) { var v = Math.abs(d[i * step + j] || 0); if (v > peak) peak = v; }
          out.push(peak); if (peak > max) max = peak;
        }
        resolve(out.map(function (p) { return max ? p / max : 0; }));
      }).catch(function () { resolve(null); });
    });
    return peakCache[src];
  }

  function init(root) {
    if (!root || root.dataset.mfReady) return;
    root.dataset.mfReady = '1';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var titleEl = root.querySelector('[data-mf-text]');
    var animHead = root.dataset.headAnim === 'true' && !reduce && !!titleEl;
    var animCount = root.dataset.countAnim === 'true' && !reduce;

    /* ---------- masked rows ---------- */
    [].forEach.call(root.querySelectorAll('[data-mf-mask]'), function (box) {
      var n = parseInt(box.dataset.mfMask, 10) || 0, seed = parseInt(box.dataset.seed, 10) || 1;
      var more = parseInt(box.dataset.more, 10) || 0, r = rng(seed * 7919), html = '', i;
      var lock = '<svg class="mf__lock" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.1" aria-hidden="true"><rect x="2.5" y="5.5" width="7" height="5"/><path d="M4 5.5V4a2 2 0 014 0v1.5"/></svg>';
      for (i = 0; i < n; i++) {
        html += '<div class="mf__row mf__mask" style="--d:' + (i * 0.35 + seed * 0.2).toFixed(2) + 's" aria-hidden="true">' + lock + '<span class="mf__fname">' + maskText(r) + '</span><span class="mf__tag"><span class="mf__tx">Locked</span></span></div>';
      }
      if (more > 0) {
        html += '<div class="mf__row mf__mask mf__more"><span></span><span class="mf__fname">+ ' + more.toLocaleString('en-US') + ' more in the pack</span><span></span></div>';
      }
      box.outerHTML = html;
    });

    /* ---------- folders ---------- */
    var folders = [].slice.call(root.querySelectorAll('[data-mf-folder]'));
    var stack = [];
    folders.forEach(function (n) {
      var lvl = parseInt(n.dataset.level, 10) || 1;
      while (stack.length && stack[stack.length - 1].lvl >= lvl) stack.pop();
      if (stack.length) {
        var kids = stack[stack.length - 1].el.querySelector('[data-mf-kids]');
        if (kids) kids.appendChild(n);
      }
      stack.push({ el: n, lvl: lvl });
    });
    var oneOpen = root.dataset.oneOpen === 'true';
    function parentOf(f) { return f.parentNode.closest('[data-mf-folder]'); }
    function setOpen(f, open) {
      if (open && oneOpen) {
        var par = parentOf(f);
        folders.forEach(function (o) {
          if (o !== f && o.classList.contains('is-open') && parentOf(o) === par) setOpen(o, false);
        });
        var head = f.querySelector('[data-mf-toggle]');
        if (head.getBoundingClientRect().top < 0) {
          setTimeout(function () { head.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' }); }, 320);
        }
      }
      if (!open) {
        folders.forEach(function (o) {
          if (o !== f && f.contains(o) && o.classList.contains('is-open')) setOpen(o, false);
        });
      }
      f.classList.toggle('is-open', open);
      f.querySelector('[data-mf-toggle]').setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    folders.forEach(function (f) {
      f.querySelector('[data-mf-toggle]').addEventListener('click', function () { setOpen(f, !f.classList.contains('is-open')); });
    });
    if (root.dataset.openFirst === 'true' && folders[0]) setOpen(folders[0], true);

    /* ---------- player ---------- */
    var player = root.querySelector('[data-mf-player]');
    var pbtn = root.querySelector('[data-mf-pbtn]');
    var titleP = root.querySelector('[data-mf-title]');
    var statusP = root.querySelector('[data-mf-status]');
    var canvas = root.querySelector('[data-mf-wave]');
    var timeP = root.querySelector('[data-mf-time]');
    var ctx = canvas.getContext('2d');
    var audio = new Audio();
    audio.preload = 'none';
    var active = null, peaks = null, raf = 0, colors = {};
    var idleTitle = titleP.textContent, idleStatus = statusP.textContent;

    function color(v) {
      var el = document.createElement('span');
      el.style.color = 'var(' + v + ')';
      root.appendChild(el);
      var c = getComputedStyle(el).color;
      root.removeChild(el);
      return c;
    }
    function draw() {
      var w = canvas.clientWidth, h = canvas.clientHeight, dpr = window.devicePixelRatio || 1;
      if (!w || !h) return;
      if (canvas.width !== Math.round(w * dpr)) { canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr); }
      colors.idle = colors.idle || color('--mf-wave');
      colors.on = colors.on || color('--mf-wave-on');
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, w, h);
      var bw = 2, gap = 2, n = Math.floor(w / (bw + gap)), prog = audio.duration ? audio.currentTime / audio.duration : 0, i;
      for (i = 0; i < n; i++) {
        var p = peaks ? peaks[Math.min(peaks.length - 1, Math.floor(i / n * peaks.length))] : 0;
        var bh = peaks ? Math.max(2, p * (h - 4)) : 2;
        ctx.fillStyle = (i / n) < prog ? colors.on : colors.idle;
        ctx.fillRect(i * (bw + gap), (h - bh) / 2, bw, bh);
      }
      timeP.textContent = fmt(audio.currentTime) + ' / ' + fmt(audio.duration);
    }
    function loop() { draw(); if (!audio.paused) raf = requestAnimationFrame(loop); }
    function setPlaying(on) {
      player.classList.toggle('is-playing', on);
      if (active) active.classList.toggle('is-playing', on);
      if (on) { cancelAnimationFrame(raf); raf = requestAnimationFrame(loop); }
    }
    function status(text, warn) { statusP.textContent = text; statusP.classList.toggle('is-warn', !!warn); }

    function stop(reset) {
      audio.pause();
      if (reset) { try { audio.currentTime = 0; } catch (e) {} }
      setPlaying(false);
      draw();
    }
    function select(btn) {
      if (active === btn && audio.src) {
        if (audio.paused) audio.play(); else audio.pause();
        return;
      }
      if (current && current.audio !== audio) current.stop(false);
      current = { audio: audio, stop: stop };
      audio.pause();
      if (active) active.classList.remove('is-active', 'is-playing');
      active = btn;
      btn.classList.add('is-active');
      peaks = null;
      titleP.textContent = btn.dataset.name;
      var src = btn.dataset.src;
      if (!src) {
        audio.removeAttribute('src');
        pbtn.disabled = true;
        setPlaying(false);
        status('Preview source not attached', true);
        draw();
        return;
      }
      pbtn.disabled = false;
      status(btn.dataset.folder + ' / loading');
      audio.src = src;
      var pr = audio.play();
      if (pr && pr.catch) pr.catch(function () { status('Source unavailable', true); setPlaying(false); });
      decodePeaks(src, 160).then(function (p) { if (active === btn) { peaks = p; draw(); } });
      draw();
    }
    audio.addEventListener('playing', function () { setPlaying(true); status(active ? active.dataset.folder + ' / playing' : ''); });
    audio.addEventListener('pause', function () { setPlaying(false); if (active && !audio.ended) status(active.dataset.folder + ' / paused'); });
    audio.addEventListener('ended', function () { setPlaying(false); audio.currentTime = 0; status(active ? active.dataset.folder + ' / ready' : ''); draw(); });
    audio.addEventListener('loadedmetadata', draw);
    audio.addEventListener('error', function () { if (audio.getAttribute('src')) { status('Source unavailable', true); setPlaying(false); } });

    [].forEach.call(root.querySelectorAll('[data-mf-file]'), function (b) { b.addEventListener('click', function () { select(b); }); });
    pbtn.addEventListener('click', function () { if (!active) return; if (audio.paused) audio.play(); else audio.pause(); });

    function seek(clientX) {
      var rect = canvas.getBoundingClientRect();
      if (audio.duration) { audio.currentTime = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width)) * audio.duration; draw(); }
    }
    canvas.addEventListener('click', function (e) { seek(e.clientX); });
    canvas.addEventListener('keydown', function (e) {
      if (!audio.duration) return;
      if (e.key === 'ArrowRight') { audio.currentTime = Math.min(audio.duration, audio.currentTime + 5); e.preventDefault(); e.stopPropagation(); }
      if (e.key === 'ArrowLeft') { audio.currentTime = Math.max(0, audio.currentTime - 5); e.preventDefault(); e.stopPropagation(); }
      draw();
    });
    window.addEventListener('resize', function () { colors = {}; draw(); });
    draw();

    /* ---------- keyboard browse ---------- */
    root.addEventListener('keydown', function (e) {
      var t = e.target;
      var isHead = t.matches && t.matches('[data-mf-toggle]');
      var isFile = t.matches && t.matches('[data-mf-file]');
      if (!isHead && !isFile) return;
      var k = e.key;
      if (['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft'].indexOf(k) < 0) return;
      e.preventDefault();
      function shown(el) {
        var f = el.closest('[data-mf-folder]');
        if (el.matches('[data-mf-toggle]')) f = f.parentNode.closest('[data-mf-folder]');
        while (f) { if (!f.classList.contains('is-open')) return false; f = f.parentNode.closest('[data-mf-folder]'); }
        return true;
      }
      var items = [].slice.call(root.querySelectorAll('[data-mf-toggle], [data-mf-file]')).filter(shown);
      var i = items.indexOf(t);
      if (k === 'ArrowDown' && items[i + 1]) items[i + 1].focus();
      else if (k === 'ArrowUp' && items[i - 1]) items[i - 1].focus();
      else if (k === 'ArrowRight') {
        if (isFile) select(t);
        else {
          var f = t.parentNode;
          if (!f.classList.contains('is-open')) setOpen(f, true);
          else if (items[i + 1] && items[i + 1].matches('[data-mf-file]')) items[i + 1].focus();
        }
      } else if (k === 'ArrowLeft') {
        if (isFile) {
          if (active === t && !audio.paused) stop(true);
          else t.closest('[data-mf-folder]').querySelector('[data-mf-toggle]').focus();
        } else if (t.parentNode.classList.contains('is-open')) setOpen(t.parentNode, false);
        else { var pf = t.parentNode.parentNode.closest('[data-mf-folder]'); if (pf) pf.querySelector('[data-mf-toggle]').focus(); }
      }
    });

    /* ---------- heading + counters ---------- */
    var TITLE = titleEl ? titleEl.textContent : '';
    var busy = false, inView = false, started = false;

    function build() {
      titleEl.textContent = '';
      var out = [];
      var words = TITLE.split(' ');
      words.forEach(function (word, wi) {
        var w = document.createElement('span');
        w.className = 'mf__w';
        word.split('').forEach(function (ch) {
          var c = document.createElement('span');
          c.className = 'mf__c';
          c.textContent = ch;
          w.appendChild(c);
          out.push({ el: c, ch: ch });
        });
        titleEl.appendChild(w);
        if (wi < words.length - 1) titleEl.appendChild(document.createTextNode(' '));
      });
      out.forEach(function (s) { s.w = s.el.getBoundingClientRect().width; });
      out.forEach(function (s) { s.el.style.width = s.w + 'px'; });
      return out;
    }
    function play(mode, done) {
      if (busy) return;
      busy = true;
      var chars = build();
      root.classList.remove('mf--prep');
      var n = chars.length, plan = [], i;
      if (mode === 'decode') {
        var step = Math.min(38, 1000 / Math.max(n, 1));
        for (i = 0; i < n; i++) plan[i] = chars[i].ch.trim() ? 240 + i * step + Math.random() * 140 : 0;
      } else {
        var pool = [];
        for (i = 0; i < n; i++) { plan[i] = 0; if (chars[i].ch.trim()) pool.push(i); }
        var hits = Math.min(pool.length, 2 + Math.floor(Math.random() * 2));
        while (hits--) { plan[pool.splice(Math.floor(Math.random() * pool.length), 1)[0]] = 200 + Math.random() * 140; }
      }
      chars.forEach(function (c, idx) { if (plan[idx]) { c.el.textContent = noise(); c.el.classList.add('is-noise'); } });
      var t0 = performance.now();
      function frame(now) {
        var elapsed = now - t0, live = false;
        chars.forEach(function (c, idx) {
          var end = plan[idx];
          if (!end || c.done) return;
          if (elapsed < end) { live = true; if (now - (c.last || 0) > 55) { c.last = now; c.el.textContent = noise(); } }
          else { c.done = true; c.el.textContent = c.ch; c.el.classList.remove('is-noise'); }
        });
        if (live) requestAnimationFrame(frame);
        else { titleEl.textContent = TITLE; busy = false; if (done) done(); }
      }
      requestAnimationFrame(frame);
    }
    function schedule() {
      setTimeout(function () {
        if (!document.body.contains(root)) return;
        if (!document.hidden && inView) play('glitch');
        schedule();
      }, 8000 + Math.random() * 5000);
    }
    var nums = [].slice.call(root.querySelectorAll('[data-mf-n], [data-mf-total]'));
    function countUp() {
      var t0 = null, dur = 900;
      function tick(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
        nums.forEach(function (el) { el.textContent = Math.round((parseInt(el.dataset.n, 10) || 0) * e).toLocaleString('en-US'); });
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    function start() {
      if (started) return;
      started = true;
      root.classList.add('is-seen');
      var go = function () {
        if (animHead) play('decode', schedule);
        if (animCount) countUp();
      };
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(go); else go();
    }
    if (animHead) root.classList.add('mf--prep');
    if (animCount) nums.forEach(function (el) { el.textContent = '0'; });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) start();
      }, { threshold: 0.2 }).observe(root);
    } else { inView = true; start(); }
  }

  function initAll(scope) { [].slice.call((scope || document).querySelectorAll('[data-mf]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
